@if (canShowOwner) {
  <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
    <mat-label>Filter by Owner</mat-label>
    <mat-select
      [(ngModel)]="selectedOwnerId"
      (selectionChange)="onOwnerChange()"
      [disabled]="loadingOwners"
      panelClass="owner-station-filter-panel">
      <mat-option [value]="''">All Owners</mat-option>
      @for (owner of owners; track owner.id) {
        <mat-option [value]="owner.id">{{ owner.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (canShowStation) {
  <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
    <mat-label>Filter by Station</mat-label>
    <mat-select
      [(ngModel)]="selectedStationId"
      (selectionChange)="onStationChange()"
      [disabled]="loadingStations"
      panelClass="owner-station-filter-panel">
      <mat-option [value]="''">All Stations</mat-option>
      @for (station of filteredStations; track station.id) {
        <mat-option [value]="station.id">{{ station.call_sign }} — {{ station.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
